import { FieldValueLookupError } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/errors/field-value-lookup-error.tsx';
import type {
	SelectPublicSetValue,
	SelectPublicGetValue,
} from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/fields/select';
import type { OptionsVisibility } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/types/options-visibility';
import { applyOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/utils/apply-options-visibility-rule';
import { getAvailableOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/utils/get-available-options-visibility-rule';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-fields-configuration/src/common/utils/common/utils/single-value-lookup';

export type SelectInternalAllowedValue = {
	id: string;
	value: string;
};

export type SelectInternalValue = null | {
	label: string;
	value: string;
};

export const transformSelectSetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: SelectInternalAllowedValue[],
): SelectInternalAllowedValue[] =>
	applyOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const transformSelectGetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: SelectInternalAllowedValue[],
): OptionsVisibility => getAvailableOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const selectSetValueTransformer = (
	value: SelectPublicSetValue,
	allowedValues?: SelectInternalAllowedValue[],
): SelectInternalValue => {
	if (value === null) {
		return null;
	}

	const foundValue = singleValueLookup<SelectInternalAllowedValue>(value, allowedValues, 'id');

	if (!foundValue) {
		throw new FieldValueLookupError();
	}

	return { value: foundValue.id, label: foundValue.value };
};

export const selectGetValueTransformer = (value: SelectInternalValue): SelectPublicGetValue => {
	if (!value) {
		return null;
	}

	const { label, value: id } = value;

	return { id, value: label };
};
